import React from 'react';
//import ReactDOM from 'react-dom'
import ReactDOM from 'react-dom/client';
import './index.css';


import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'animate.css/animate.min.css';
import WOW from 'wowjs';
import 'animate.css';

import './assets/styles/style.css';

import './utils/main.js';
import App from './App';
//import * as serviceWorker from './serviceWorker';
import 'jquery/dist/jquery.min.js';
import 'popper.js/dist/umd/popper.min.js';
import 'bootstrap/dist/js/bootstrap.min.js'
import * as serviceWorker from './ServiceWorker.js'; // Ensure this import statement points to the correct path
new WOW.WOW().init();



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
  
);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
serviceWorker.unregister();

